// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dji8","right":"styles_right__2jUww"};